import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';

export default CalendarTodayRoundedIcon;
